<template>
  <transition name="loader">
    <div class="loader-screen">
    </div>
  </transition>
</template>

<script>
import store from '../store'

export default {
  name: 'loader',
  computed: {
    loaderVisible() {
      return store.state.showLoader
    },
  },
}
</script>

<style scoped lang="scss">

@import '../theme';

.loader-screen {
  position: fixed;
  z-index: zespri-layer(modal);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  display: flex;
  transition: opacity .3s ease;
  justify-content: center;
  align-items: center;
  background-color: rgba(zespri-brand-color(dark-green), .85);

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 75px;
    height: 75px;
    background-image: url("data:image/svg+xml,%3Csvg width='38' height='38' viewBox='0 0 38 38' xmlns='http://www.w3.org/2000/svg' stroke='%23fff'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(1 1)' stroke-width='2'%3E%3Ccircle stroke-opacity='.5' cx='18' cy='18' r='18'/%3E%3Cpath d='M36 18c0-9.94-8.06-18-18-18'%3E%3CanimateTransform attributeName='transform' type='rotate' from='0 18 18' to='360 18 18' dur='1s' repeatCount='indefinite'/%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
  }
}

</style>
